module.exports = __webpack_public_path__ + "static/media/noLists.b1f502a5.png";